<template>
    <div class="l-listings">
        <div class="container">
            <div class="e-searchtop" v-if="showSearchResultsHeading && filters.keywords">
                <p>Showing results for: {{filters.keywords}}</p>
            </div>

            <div class="row">
                <section class="m-filters">
                    <h2 class="font-scale-s">Refine Results:</h2>
                    <search-filters></search-filters>
                </section>

                <div class="items">
                    <div class="e-resulttext">
                        Showing {{resultsLoaded}} of {{resultCount}} results
                    </div>
                    <span class="e-noresults" v-if="!loading && resultCount == 0">
                        There's no results that match your selection, please refine your search.
                    </span>
                    <div v-for="searchResult in searchResults" :key="searchResult.Id" :class="{ staffmemberresult : searchResult.DocType == 'staffMember' }">
                        <blog-list-item :result-item="searchResult" v-if="searchResult.DocType == 'blogArticle'" :hideImage="true"></blog-list-item>
                        <events-list-item :result-item="searchResult" view="search" v-else-if="searchResult.DocType == 'event'" :hideImage="true"></events-list-item>
                        <news-list-item :result-item="searchResult" v-else-if="searchResult.DocType == 'newsArticle'" :hideImage="true"></news-list-item>
                        <property-list-item :result-item="searchResult" v-else-if="searchResult.DocType == 'property'" :hideImage="true"></property-list-item>
                        <staff-list-item :result-item="searchResult" :location-link="locationLink" v-else-if="searchResult.DocType == 'staffMember'" :hideImage="true"></staff-list-item>
                        <search-list-item :result-item="searchResult" :hideImage="true" v-else></search-list-item>
                    </div>
                </div>
            </div>


            <div class="e-viewmore" v-if="resultCount > 0">
                <span>Showing {{resultsLoaded}} of {{resultCount}} results</span>

                <search-pager v-if="moreResultsAvailable"></search-pager>
            </div>
        </div>
    </div>
</template>

<script>
    import BlogListItem from '@/components/BlogSearch/blog-list-item'
    import EventsListItem from '@/components/EventSearch/events-list-item'
    import NewsListItem from '@/components/NewsSearch/news-list-item'
    import PropertyListItem from '@/components/PropertySearch/property-list-item'
    import SearchFilters from '@/components/SiteSearch/search-filters'
    import SearchListItem from '@/components/SiteSearch/search-list-item'
    import SearchPager from '@/components/SiteSearch/search-pager'
    import StaffListItem from '@/components/StaffSearch/staff-list-item'

    import { globalMixin } from '@/mixins/globalMixin.js'
    import { searchMixin } from '@/mixins/searchMixin.js'

    export default {
        components: {
            BlogListItem,
            EventsListItem,
            NewsListItem,
            PropertyListItem,
            SearchFilters,
            SearchListItem,
            SearchPager,
            StaffListItem
        },

        computed: {
            filters: {
                get() {
                    return this.$store.state.search.filters
                },
                set() { }
            },

            moreResultsAvailable: function () {
                return this.$store.getters.moreResultsAvailable
            },

            resultsLoaded: function () {
                return this.$store.state.search.resultsLoaded
            },

            searchResults: function () {
                return this.$store.state.search.results
            },

            resultCount: function () {
                return this.$store.state.search.resultCount
            }
        },

        created: function () {
            this.$eventHub.$on('search-filtersChanged', this.OnFiltersChanged)
            this.$eventHub.$on('search-pageChanged', this.OnPageChanged)

            this.$store.dispatch('updateSearchFilter', { key: 'page', value: 1 })
            this.$store.dispatch('updateSearchFilter', { key: 'showAllResults', value: false })

            this.search(true)
        },

        data() {
            return {
                searchApiUrl: '/umbraco/api/SearchApi/Search'
            }
        },

        methods: {
            OnFiltersChanged: function () {
                this.search(true)
            },

            OnPageChanged: function () {
                this.search()
            }
        },

        mixins: [globalMixin, searchMixin],

        props: {
            locationLink: {
                default: null,
                type: String
            },

            showSearchResultsHeading: {
                default: false,
                type: Boolean
            }
        }
    }
</script>